export const POPULAR_SEARCHES_ROUTE = '/popular-searches';
export const QP_PAGE = 'page';
